/**
 * [Phase 2c.6-A.2.1 D-2 / RL-35] SnakeDraftBoardPage
 *
 * Route wrapper for the standalone snake draft board. Opens at
 * /draft-snake/:leagueId/board (typically in a new tab from a
 * "DRAFT BOARD ↗" button inside the SnakeDraftRoom). Mounts a
 * dedicated SnakeDraftProvider so this page maintains its own WS
 * connection to the snake draft engine.
 *
 * [BOARD MIRROR] `silent` - the board is a VISUAL surface. Its provider must
 * never enqueue Adam, or the board tab talks over the tab the manager is
 * actually sitting in (live bug: two voices in the room).
 */
import { useParams } from "react-router-dom";
import { SnakeDraftProvider } from "../contexts/SnakeDraftContext";
import SnakeStandaloneDraftBoard from "../components/snake/SnakeStandaloneDraftBoard";

export default function SnakeDraftBoardPage() {
  const { id } = useParams();
  return (
    <SnakeDraftProvider leagueId={id} silent>
      <SnakeStandaloneDraftBoard />
    </SnakeDraftProvider>
  );
}
